/**
 * Internal dependencies.
 */
import edit from './edit';
import metadata from './block.json';
import { GalleryCarouselIcon as icon } from '../../components/Icons';

/**
 * WordPress dependencies.
 */
import { __ } from '@wordpress/i18n';
import { Icon } from '@wordpress/components';

/**
 * Block constants
 */
const { name, category, attributes } = metadata;

const settings = {
	title: __( 'Gallery Carousel' ),
	description: __( 'Gutenify Gallery Carousel.' ),
	icon: <Icon icon={ icon } />,
	keywords: [
		'gutenify',
		__( 'Gallery Carousel' ),
		__( 'Gallery' ),
		__( 'Carousel' ),
		__( 'Slider' ),
		__( 'Sliders' ),
	],
	example: {
		attributes: {
		},
	},
	attributes,
	edit,
	save: () => {},
	supports: {
		html: false,
		align: [ 'center', 'wide', 'full' ],
	},
};

export { name, category, settings };
